import { createApi } from "@reduxjs/toolkit/query/react";
import { createBaseQueryWithLogoutGuard } from "../../common/createBaseQueryWithLogoutGuard";
import store from "../../../app/store";
import {
  setAssetSize,
  setResetSearchTextForCities,
  setSelectedCities,
} from "./cohortSlice";

export const _authToken = () => {
  const state = store.getState();
  return `${state?.authReducer?.userData?.tokenType?.toLowerCase()} ${
    state?.authReducer?.userData?.token
  }`;
};

export const _idrssd = () => {
  const state = store.getState();
  return state?.orgReducer?.selectedFI?.idrssd;
};

export const _fiType = () => {
  const state = store.getState();
  return state?.orgReducer?.selectedFI?.fi_Type?.toLowerCase() === "fcu"
    ? "fcu"
    : "bank";
};

export const _selectedQuarter = () => {
  const state = store.getState();
  return state?.ewiReducer?.selectedQuarter;
};

// ---------------------------------------------------------
// RTK Query API
// ---------------------------------------------------------
export const cohortRTK = createApi({
  reducerPath: "cohortRTK",
  baseQuery: createBaseQueryWithLogoutGuard({
    baseUrl: process.env.REACT_APP_API_URL,
  }),
  tagTypes: [
    "GetCities",
    "GetInstitutions",
    "GetCohortDetailsList",
    "GetCohortList",
  ],
  endpoints: (builder) => ({
    // ----------------------------------------
    // GET STATES LIST
    // ----------------------------------------
    getCitiesList: builder.query({
      query: () => ({
        url: `/bank/fhs/state?fi_type=${_fiType()}`,
        method: "GET",
        headers: {
          Authorization: _authToken(),
          "Content-Type": "application/json",
        },
      }),
      providesTags: ["GetCities"],
    }),
    // ----------------------------------------
    // GET INSTITUTION LIST
    // ----------------------------------------
    getInitialFIList: builder.query({
      query: () => ({
        url: `/bank/fhs/cohort?fi_type=${_fiType()}`,
        method: "GET",
        headers: {
          Authorization: _authToken(),
          "Content-Type": "application/json",
        },
      }),
      transformResponse: (response) => {
        return response.data.reduce((acc, item) => {
          acc[item.idrssd] = {
            financialInstitute: item.financialInstitute,
            idrssd: item.idrssd,
            fiType: item.fiType,
          };
          return acc;
        }, {});
      },
      providesTags: ["GetInstitutions"],
    }),
    // ----------------------------------------
    // GET COHORT DETAILS LIST
    // ----------------------------------------
    getCohortDetailsList: builder.query({
      query: () => {
        return {
          url: `/bank/${_idrssd()}/cohort`,
          method: "GET",
          headers: {
            Authorization: _authToken(),
            "Content-Type": "application/json",
          },
        };
      },
      providesTags: ["GetCohortDetailsList"],
    }),
    // ----------------------------------------
    // DELETE COHORT
    // ----------------------------------------
    deleteCohort: builder.mutation({
      query: ({ cohortId }) => ({
        url: `/bank/${_idrssd()}/cohort/${cohortId}`,
        method: "DELETE",
        headers: {
          Authorization: _authToken(),
          "Content-Type": "application/json",
        },
      }),
      async onQueryStarted(_arg, { dispatch, queryFulfilled }) {
        await queryFulfilled;
        dispatch(setResetSearchTextForCities(true));
        dispatch(setSelectedCities([]));
        dispatch(
          setAssetSize({
            minValue: null,
            maxValue: null,
          }),
        );
      },
      invalidatesTags: ["GetCohortDetailsList", "GetCohortList"],
    }),
  }),
});

export const {
  useGetCitiesListQuery,
  useGetInitialFIListQuery,
  useGetCohortDetailsListQuery,
  useDeleteCohortMutation,
} = cohortRTK;
